
import ProductEditComponent from "../../../components/products/Edit.vue";

export default {
  components: {
    ProductEditComponent
  }
};
